(function () {
  function formatMoney(cents, formattedFallback) {
    if (typeof cents === 'number' && window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    if (typeof cents === 'number') {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }
    return formattedFallback || '';
  }

  function productJsonUrl() {
    var path = window.location.pathname.replace(/\/$/, '');
    if (!path) return null;
    return path + '.js';
  }

  function fetchProductVariants() {
    var url = productJsonUrl();
    if (!url) return Promise.resolve(null);
    return fetch(url)
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (product) {
        if (!product || !product.variants) return null;
        return product.variants.map(function (v) {
          return {
            id: String(v.id),
            title: v.title,
            option1: v.option1,
            option2: v.option2,
            option3: v.option3,
            sku: v.sku || '',
            mfr: v.sku || '',
            price: v.price,
            price_formatted: formatMoney(v.price),
            compare_at: v.compare_at_price || 0,
            compare_at_formatted: formatMoney(v.compare_at_price || 0),
            available: v.available
          };
        });
      })
      .catch(function () { return null; });
  }

  function parseVariantsFromJson(scope) {
    var jsonEl = document.getElementById('tcb-product-variants-json') ||
      scope.querySelector('[data-tcb-product-variants]') ||
      document.getElementById('tcb-product-variants-data');
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function parseVariantsFromSelect(select) {
    if (!select) return [];
    return Array.prototype.map.call(select.options, function (opt) {
      return {
        id: opt.value,
        title: (opt.textContent || '').trim(),
        option1: (opt.textContent || '').trim(),
        option2: null,
        option3: null,
        sku: opt.getAttribute('data-sku') || '',
        mfr: opt.getAttribute('data-mfr') || opt.getAttribute('data-sku') || '',
        price: parseInt(opt.getAttribute('data-price-cents') || '', 10) || 0,
        price_formatted: opt.getAttribute('data-price') || '',
        available: !opt.disabled
      };
    });
  }

  function parseVariantsFromCards(picker) {
    var cards = picker.querySelectorAll('.tcb-variant-card[data-variant-id], .tcb-variant-pill[data-variant-id]');
    if (!cards.length) return null;
    return Array.prototype.map.call(cards, function (card) {
      return {
        id: card.getAttribute('data-variant-id'),
        title: card.getAttribute('data-variant-title') || '',
        option1: card.getAttribute('data-option-value') || '',
        option2: null,
        option3: null,
        sku: card.getAttribute('data-variant-sku') || '',
        mfr: card.getAttribute('data-variant-mfr') || '',
        price: parseInt(card.getAttribute('data-variant-price-cents') || '', 10) || 0,
        price_formatted: card.getAttribute('data-variant-price') || '',
        compare_at: parseInt(card.getAttribute('data-variant-compare-cents') || '', 10) || 0,
        compare_at_formatted: formatMoney(parseInt(card.getAttribute('data-variant-compare-cents') || '', 10) || 0),
        available: card.getAttribute('data-variant-available') !== 'false'
      };
    });
  }

  function initVariantPicker(scope) {
    var picker = scope.querySelector('[data-tcb-variant-picker]');
    if (!picker || picker.getAttribute('data-tcb-bound') === '1') return;

    var idField = picker.querySelector('[data-tcb-variant-id]') ||
      picker.querySelector('select[name="id"]') ||
      scope.querySelector('select[name="id"]');

    if (!idField) {
      var form = scope.querySelector('.tcb-cart-form, form[action*="/cart/add"]');
      idField = form ? form.querySelector('[data-tcb-variant-id], select[name="id"]') : null;
    }
    if (!idField) return;

    picker.setAttribute('data-tcb-bound', '1');

    var variants = parseVariantsFromJson(scope) ||
      parseVariantsFromCards(picker) ||
      parseVariantsFromSelect(idField.tagName === 'SELECT' ? idField : picker.querySelector('select[name="id"]')) ||
      [];

    function selectedOptions() {
      var options = [];
      picker.querySelectorAll('.tcb-variant-group').forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10) || 0;
        var checked = group.querySelector('input[data-option-value]:checked');
        options[idx] = checked ? checked.value : null;
      });
      return options;
    }

    function findVariant() {
      var checked = picker.querySelector('input[data-option-value]:checked');
      var card = checked ? checked.closest('.tcb-variant-card, .tcb-variant-pill') : null;
      if (card && card.getAttribute('data-variant-id')) {
        return {
          id: card.getAttribute('data-variant-id'),
          title: card.getAttribute('data-variant-title') || checked.value,
          option1: card.getAttribute('data-option-value') || checked.value,
          sku: card.getAttribute('data-variant-sku') || '',
          mfr: card.getAttribute('data-variant-mfr') || '',
          price: parseInt(card.getAttribute('data-variant-price-cents') || '', 10) || 0,
          price_formatted: card.getAttribute('data-variant-price') || '',
          compare_at: parseInt(card.getAttribute('data-variant-compare-cents') || '', 10) || 0,
          compare_at_formatted: formatMoney(parseInt(card.getAttribute('data-variant-compare-cents') || '', 10) || 0),
          available: card.getAttribute('data-variant-available') !== 'false'
        };
      }

      var selected = selectedOptions().filter(Boolean);
      if (!selected.length) return variants[0];

      var match = variants.find(function (v) {
        return (
          (!v.option1 || v.option1 === selected[0]) &&
          (!v.option2 || v.option2 === selected[1]) &&
          (!v.option3 || v.option3 === selected[2])
        );
      });

      if (match) return match;

      match = variants.find(function (v) {
        return selected.every(function (val) {
          return (v.title && v.title.indexOf(val) > -1) ||
            (v.option1 && v.option1 === val);
        });
      });

      return match || variants.find(function (v) { return String(v.id) === String(idField.value); }) || variants[0];
    }

    function syncCards() {
      picker.querySelectorAll('.tcb-variant-card, .tcb-variant-pill').forEach(function (el) {
        var input = el.querySelector('input[data-option-value]');
        el.classList.toggle('is-selected', !!(input && input.checked));
      });
    }

    function updateCompareUI(variant) {
      var compareEl = scope.querySelector('[data-tcb-compare-display]');
      var saveEl = scope.querySelector('[data-tcb-save-display]');
      var stickyPrice = scope.querySelector('[data-tcb-sticky-price]');
      var compareAt = variant.compare_at || 0;
      var price = variant.price || 0;
      if (compareEl) {
        if (compareAt > price) {
          compareEl.textContent = variant.compare_at_formatted || formatMoney(compareAt);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (saveEl) {
        if (compareAt > price) {
          saveEl.textContent = 'Save ' + formatMoney(compareAt - price);
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant) return;

      idField.value = variant.id;
      if (idField.tagName === 'SELECT') {
        idField.dispatchEvent(new Event('change', { bubbles: true }));
      }

      var priceText = variant.price_formatted || formatMoney(variant.price, variant.price_formatted);
      var priceEl = scope.querySelector('[data-tcb-price-display]');
      if (priceEl && priceText) priceEl.textContent = priceText;

      var checkoutPanel = scope.querySelector('.tcb-checkout-panel');
      if (checkoutPanel && priceText) {
        checkoutPanel.setAttribute('data-tcb-price', priceText.replace(/\.00$/, ''));
      }

      var stickyPrice = scope.querySelector('[data-tcb-sticky-price]');
      if (stickyPrice && priceText) stickyPrice.textContent = priceText;

      updateCompareUI(variant);

      var tablePrice = scope.querySelector('.tcb-table-price');
      if (tablePrice && priceText) tablePrice.textContent = priceText;

      var itemSku = scope.querySelector('[data-tcb-item-sku]');
      if (itemSku && variant.sku) itemSku.textContent = variant.sku;

      var mfrSku = scope.querySelector('[data-tcb-mfr-sku]');
      if (mfrSku && variant.mfr) mfrSku.textContent = variant.mfr;

      var addBtn = scope.querySelector('[data-tcb-add-btn]');
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to Cart' : 'Currently Unavailable';
      }

      var stickyAdd = scope.querySelector('[data-tcb-sticky-add]');
      if (stickyAdd) {
        stickyAdd.disabled = !variant.available;
        stickyAdd.textContent = variant.available ? 'Add to Cart' : 'Unavailable';
      }

      syncCards();
      document.dispatchEvent(new CustomEvent('tcb:variant-change', { detail: { variant: variant } }));
    }

    function selectCardInput(input) {
      if (!input) return;
      var group = input.closest('.tcb-variant-cards, .tcb-variant-pills, .tcb-variant-group');
      if (group) {
        group.querySelectorAll('input[data-option-value]').forEach(function (radio) {
          radio.checked = false;
        });
      }
      input.checked = true;
      updateUI();
    }

    picker.addEventListener('change', function (e) {
      if (e.target && e.target.matches('input[data-option-value]')) updateUI();
    });

    picker.addEventListener('click', function (e) {
      var card = e.target.closest('.tcb-variant-card, .tcb-variant-pill');
      if (!card) return;
      selectCardInput(card.querySelector('input[data-option-value]'));
    });

    if (variants.length) {
      updateUI();
      return;
    }

    fetchProductVariants().then(function (fetched) {
      if (fetched && fetched.length) {
        variants = fetched;
        updateUI();
      }
    });
  }

  function boot() {
    var root = document.querySelector('.tcb-pro');
    if (!root) return;

    var mainImg = root.querySelector('.tcb-main-img');
    root.querySelectorAll('.tcb-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg || !thumb.src) return;
        mainImg.src = thumb.src.replace(/width=\d+/, 'width=1500');
        root.querySelectorAll('.tcb-thumb').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    initVariantPicker(root);

    if (window.jdgm && typeof window.jdgm.loadWidgets === 'function') {
      window.jdgm.loadWidgets();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
